import React from 'react';

import { useIntl } from 'react-intl';

import ActionButton from 'components/action-button';
import { useSignInUpAfterCartExperiment } from 'experiments/use-sign-in-up-after-cart-experiment';
import { useAuthContext } from 'state/auth';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { routes } from 'utils/routing';

const SignUpToContinueActionLink = () => {
  const { formatMessage } = useIntl();
  const showSignUpToContinue = useFlag(LaunchDarklyFlag.ENABLE_SIGNUP_CART_BUTTON_TEXT);
  const { openSignInModal } = useAuthContext();
  const isSignInUpAfterCartExperimentEnabled = useSignInUpAfterCartExperiment();

  const handleSignUpToContinuePress = () => {
    openSignInModal({
      navigateOnSuccessRoute: routes.cart,
    });
  };

  let buttonText = '';

  if (isSignInUpAfterCartExperimentEnabled) {
    buttonText = formatMessage({ id: 'signUpOrLoginToContinue' });
  } else {
    buttonText = formatMessage({ id: showSignUpToContinue ? 'signUpToContinue' : 'continue' });
  }

  return (
    <ActionButton onPress={handleSignUpToContinuePress} fullWidth>
      {buttonText}
    </ActionButton>
  );
};

export default SignUpToContinueActionLink;
